// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.gcl-button {\n    border-radius: 6px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/apps/login/App.vue"],"names":[],"mappings":";AASA;IACI,6BAA6B;AACjC","sourcesContent":["<script setup lang=\"ts\">\n</script>\n\n<template>\n    <router-view/>\n</template>\n\n<style>\n\n.gcl-button {\n    border-radius: 6px !important;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
